// Critical JavaScript - Minimal essential functionality only

// Essential no-js class removal
document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

// Essential accessibility for details elements
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCriticalAccessibility);
} else {
  initCriticalAccessibility();
}

function initCriticalAccessibility() {
  // Only handle details elements that don't already have proper attributes
  document.querySelectorAll('details:not([data-critical-init]) summary').forEach((summary) => {
    const details = summary.parentNode;
    details.setAttribute('data-critical-init', 'true');
    
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.hasAttribute('open'));

    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      setTimeout(() => {
        event.currentTarget.setAttribute('aria-expanded', details.hasAttribute('open'));
      }, 0);
    });
  });
}

// Essential escape key functionality for details
document.addEventListener('keyup', function(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
});

// Mark that critical JS is loaded
window.criticalJSLoaded = true;